export const UNIT_SIZE_FILTER = 'Unit_Type';
export const AMENITIES_TYPE_FILTER = 'Amenities';
export const ALL_UNIT_FILTER_VALUE = 'All';
export const UNIT_TYPE_FILTER_NAME = 'Unit Type';
export const AMENITIES_TYPE_FILTER_NAME = 'Amenities';
export const MAIN_FILTER_HEADING = 'Filter';
export const ALERT_MODAL_CONFIG = {
  warningTitle: 'Warning',
  warningMessage:
    'This location is not associated with your current logged in account. Proceed to logout in order to access this location.',
  warningNote: 'Moving ahead will logout from the current session',
  loginToDiffAccount: 'Login to different account',
  rent: 'Rent',
  reserve: 'Reserve',
};
